/* Courier account codes (verbatim from mockup core.js). */
import {SUPPLY_DATA} from './_v6Data'

export const DUMMY_CODES = SUPPLY_DATA.codes

export const DUMMY_CODES_BY_CODE = DUMMY_CODES.reduce((m, c) => {
  m[c.code] = c
  return m
}, {})

export const codesFor = (parentId) => DUMMY_CODES.filter((c) => c.parentId === parentId)

/* Agreement-status badge derivation (TRD §M0.11) for a courier code. */
export const codeAgreementBadge = (code) => {
  const v = code.agr
  if (v === 'signed') return {key: 'signed', tip: 'Operating under the current signed agreement.'}
  if (v === 'addendum')
    return {
      key: 'addendum',
      tip: 'Signed agreement in force; a newer addendum is email-received and pending signature. Current commercials governed by the previous signed addendum.',
    }
  if (v === 'pending')
    return {key: 'approvalpending', tip: 'Only a Stage 1 (email received) agreement exists — signed agreement pending.'}
  return {key: 'norecord', tip: 'No agreement on file for this code.'}
}
